import { render } from "./comingsoon.vue?vue&type=template&id=57429038"
import script from "./comingsoon.vue?vue&type=script&lang=js"
export * from "./comingsoon.vue?vue&type=script&lang=js"

import "./comingsoon.vue?vue&type=style&index=0&id=57429038&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__